export const GET_CARRIER_TYPES = "GET_CARRIER_TYPES";
export const GET_CARRIER_TYPES_SUCCESS = "GET_CARRIER_TYPES_SUCCESS";
export const GET_CARRIER_TYPES_ERROR = "GET_CARRIER_TYPES_ERROR";
